import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'is280MmDeepPrismaXsEnclosure',
    standalone: false
})
export class Is280MmDeepPrismaXsEnclosurePipe implements PipeTransform {

  transform(enclosure): boolean {
    return enclosure?.ipType === 'IP55' ? true : false;
  }

}
